module.exports = __webpack_public_path__ + "img/pbg.71f5693b.png";